






















































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";
import HomeContent from "@/components/HomeContent.vue";
import HomeBenefits from "@/components/HomeBenefits.vue";
import SliderModule from "@/components/SliderModule.vue";
import OtherModules from "@/components/OtherModules.vue";
import { HomeInfo, Benefits, Levels } from "@/interfaces/general";
import LevelHome from "@/components/LevelHome.vue";
@Component({
  metaInfo() {
    return {
      title: "Mos - Home"
    };
  },
  components: {
    LevelHome,
    OtherModules,
    SliderModule,
    HomeBenefits,
    HomeContent
  },
  computed: {},
  methods: {}
})
export default class Home extends Mixins(GlobalMixin) {
  homeContent: HomeInfo[] = [
    {
      title: "Endeavour Management Operating System",
      text: [
        "The capture Mechanisms, management tools and use of operations data across the geology, mining, processing, maintenance and commercial functions at Endeavour are currently very rudimentary. They are often very heavily reliant on manual and time consuming processes using excel spreadsheets. ",
        "There is no hardware nor software platform that allows for data integration system across the Group. There is no cohesive data model to have a single source of trust which give the ability to be interoperable, to connect and to interconnect both data and information from different sites. As a result, operations management, planning and budgeting processes are very slow, vague and often based on inaccurate data.",
        "This challenge is evident in performance variability and difficulties delivering agreed budgets & cash flows. Beyond that, this is really one of the barriers to EDV transforming and being able to make the best decisions as fast as possible."
      ],
      image: "home/computegoldy.svg",
      alignText: "right",
      redirect: false
    }
  ];
  homeContentHowWorks: HomeInfo[] = [
    {
      text: [
        "1) EDV MOS gathers data from all disparate data sources from all sites in a powerful data base.",
        "2) EDV MOS processed  data based on business intelligence concepts to empower and better analysis.",
        "3) EDV MOS displays relevant reports and dashboards in different modules to enhance decision making and management of mining activities."
      ],
      image: "home/how works.svg",
      alignText: "left",
      redirect: false
    }
  ];
  homeContentModules: HomeInfo[] = [
    {
      title: "Value Chain Reconciliation",
      text: [
        "A standard, accessible, and efficient reconciliation tool to assist in data entry, governance, and analysis tasks associated with the end of month value chain reconciliation.",
        "The MOS reconciliation module completely supersedes the use of slow and cumbersome spreadsheets for distributing reconciliation results across the business.",
        "The MOS reconciliation module is linked to the MOS mining and processing modules which automate the entire reconciliation system."
      ],
      image: "home/Pit.svg",
      alignText: "right",
      redirect: true
    },
    {
      title: "Open Pit Mine Data Management",
      text: [
        "Managing the complexity of multiple mining fronts, differents ore types, delays, breakdowns, and ever-changing forecasts is not easy. With the MOS mine data management module (Aka the Mining Module) data capture, reporting, and analysis tasks are made more efficient giving the team more time to dig into the data to help make smarter decisions.",
        "The MOS mining module captures data in the primary areas of mining operation: Grade Control, Production, Fleet Management, Stockpile Management, Blend & Crusher Feed, Drill & Blast, Planning, Maintenance, Cost Management and Dispatch."
      ],
      image: "home/data.svg",
      alignText: "left",
      redirect: true
    },
    {
      title: "Schedule, Equipment Requirements & OPEX Forecast Manager\n",
      text: [
        "Manage multiple scenarios, estimate equipment requirements, and calculate operating costs. The MOS schedule, equipment requirements, and OPEX forecast manager improves collaboration between engineering, geology, processing, finance, and management teams and enables submission of forecasts for review and approval, version control, and comparison and sensitivity analysis.",
        "The MOS schedule, equipment requirements, and OPEX forecast manager can be used for weekly, monthly, annual budget, and life-of-mine plan management improving communication efficiency quality, and reporting interoperability and will help ensure plans are delivered accurately and on time. "
      ],
      image: "home/schedule.svg",
      alignText: "right",
      redirect: false
    },
    {
      title: "Continuos Improvement",
      text: [
        "MOS continuous improvement module supports improvement and innovation management and supports better project execution. ",
        "The module enables idea capture, benefits definition, sharing socialization and project management and ensures all lessons learned are leveraged across the business.",
        "The MOS continuous improvement module gives users access to a library of ideas and dashboards that will be used to share opportunities for improvement and innovation."
      ],
      image: "home/improvement.svg",
      alignText: "left",
      redirect: true
    },
    {
      title: "Process Plant Data Management",
      text: [
        "Replacing unsecured Excel-based metallurgical accounting and process control systems is critical for mining companies looking to step-change and automate process plant data management.",
        "The MOS processing data module (aka the processing module) replaces spreadsheets with an integrated and interoperable solution that links to existing planning, mine production, laboratory, and reconciliation tools to automate plant reporting and analysis.",
        "The MOS Processing Module integrates seamlessly with process plant historians and process control and automation system enabling centralization of data analysis and decision making support."
      ],
      image: "home/process.svg",
      alignText: "right",
      redirect: false
    }
  ];
  carousel: number = 0;
  carouselContent: object[] = [
    {
      icon: "InfoIcon.svg",
      title: "A world of data",
      content: [
        "90% of data in the world today has been in the last three years."
      ]
    },
    {
      icon: "dataOrganization.svg",
      title: "Data in organizations",
      content: [
        "Most Organizations today analyze about 12% of the data they have on hand."
      ]
    },
    {
      icon: "dataDrive.svg",
      title: "Data-driven decision making",
      content: [
        "98.6% of executives indicate that their organization aspired to a data-driven culture.",
        "Only 32.4% report having success in their aspiration."
      ]
    },
    {
      icon: "dataProject.svg",
      title: "Data projects success rate among world companies",
      content: [
        "79.8% of respondents stated better decisions as a direct outcome of a successful data project."
      ]
    },
    {
      icon: "trend.svg",
      title: "Trends",
      content: [
        "loT will bring an exponential increase in data availability.",
        "Ai & machine learning are becoming a common commercial solution for business optimization.",
        "The big data market is booming."
      ]
    },
    {
      icon: "callAction.svg",
      title: "Call to action",
      content: [
        "The Endeavour management operating System is a business critical project that will determine the future success of our organization."
      ]
    }
  ];
  anticipatedBenefits: Benefits[] = [
    {
      title: "Data accuracy & availability",
      align: true,
      content:
        "Better information is presented at the right time in the right way and to the right people to make better decisions.."
    },
    {
      title: "Advanced technologies",
      align: true,
      content:
        "Automated reports and data mining, automated task management, use of loT and real-time dashboard engines."
    },
    {
      title: "Business intelligence & data science",
      align: true,
      content: "Unleashing information intelligence from data."
    },
    {
      title: "Governance",
      align: true,
      content: "Improved data visibility and transparency of all activities."
    },
    {
      title: "Safety",
      align: true,
      content: "Enhanced operational security."
    },
    {
      title: "Cost saving",
      align: true,
      content:
        "Cost optimization, improved contractor management, and better stock control."
    }
  ];
  benefits: Benefits[] = [
    {
      image: "home/nube.svg",
      title: "Data Portal",
      content:
        "MOS gathers all the data in a fast, accessible database that can be consulted by everyone,  depending on the level of authorization of each user with the possibility of downloading."
    },
    {
      image: "home/grafico.svg",
      title: "Report & Dashboard Platform",
      content:
        "Latest generation reporting and automatic dashboarding platform. Display of relevant KPIs and graphs to improve decision making and facilitate business management."
    },
    {
      image: "home/codigo.svg",
      title: "Data Audition",
      content:
        "All those who enter data are listed, any modification is traceable, complete transparency in terms of data quality and reliability with the MOS."
    },
    {
      image: "home/dos.svg",
      title: "Automation",
      content:
        "All those who enter data are listed, any modification is traceable: complete transparency in terms of data quality and reliability with the MOS. "
    },
    {
      image: "home/chip.svg",
      title: "Digital Transformation",
      content:
        "MOS represents an integrated solution for EDV to have one sole source of data from various assets. One view interface for better collaborative work. A great step towards industry 4.0"
    }
  ];
  mobileImages = ["home/Tablet.png", "home/Phone.png"];

  levels: Levels[] = [
    {
      level: 1,
      content: ["New company."]
    },
    {
      level: 2,
      content: ["Immature & evolving systems."]
    },
    {
      level: 3,
      now: true,
      content: ["Developing data management standards."]
    },
    {
      level: 4,
      content: [
        "Enabling operational data visibility through KPI dashboards & reports."
      ]
    },
    {
      level: 5,
      content: [
        "Knowledge sharing continuous improvement, leveraging data to inform better planning."
      ]
    },
    {
      level: 6,
      content: [
        "Enabling automation of complex tasks, using machine learning and artificial intelligence to challenge the status quo, training, and development of the next generation of mining professionals. "
      ]
    },
    {
      level: 7,
      content: [
        "Using data as a differentiator.",
        "Optimizing plans that are consistently delivered.",
        "Reliably managing complex orebodies.",
        "High level of automation reducing risk and uncertainty while improving productivity and reducing costs. "
      ]
    }
  ];
  screenWidth: string = this.$vuetify.breakpoint.width.toString();
  logoWidth: string = (this.$vuetify.breakpoint.width / 1.5).toString();

  @Watch("$vuetify.breakpoint.width") onChange(val: number) {
    this.screenWidth = val.toString();
    this.logoWidth = (val / 1.5).toString();
  }
}
